import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonService, AlertService, ProfileService, AdminService } from '../../_services/';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {Location} from '@angular/common';

import { AngularFireStorage } from '@angular/fire/storage';
import { Observable, Subject } from "rxjs";
import { map, finalize, takeUntil } from "rxjs/operators";
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.scss']
})
export class EditProfileComponent implements OnInit, OnDestroy {
  userId:String;
  editProfileForm:FormGroup;
  selectedFile:File;
  imageURL:String;
  errMsg:String;
  successMsg:String;
  downloadURL: Observable<string>;
  ref:any;
  contactId:any;
  profileImagePath:String;
  detroyed$ = new Subject();
  private subscription: Subscription;
  private subscription2: Subscription;
  constructor(
    private _profile : ProfileService,
    private formBuilder: FormBuilder,
    private _location: Location,
    private _common : CommonService,
    private afStorage: AngularFireStorage,
    private _admin : AdminService
  ) { }

  ngOnInit() {
    
    this.userId = localStorage.getItem('uid')? localStorage.getItem('uid'):'';
    if(this.userId==''){
      this.errMsg = 'Session Expired. Please login again';
    }
    else{
      this.getProfileDetail(this.userId);
    }
    this.editProfileForm = this.formBuilder.group({
      first_name: [null, [Validators.required]],
      last_name: [null, [Validators.required]],
      mobile_phone: ["", []],
      file: [null, [Validators.required]]
    })
  }

  
  backClicked() {
    this._location.back();
  }

  getProfileDetail(userId){
    this.subscription = this._profile.getProfileDetail(userId).pipe(takeUntil(this.detroyed$)).subscribe(res=>{
      this.contactId = res[0].payload.doc.id;
      let firstName = res[0].payload.doc.data()['first_name']? res[0].payload.doc.data()['first_name'] : '';
      let lastName = res[0].payload.doc.data()['last_name']? res[0].payload.doc.data()['last_name'] : '';
      this.subscription2 = this._profile.getProfilePhoto(this.contactId).subscribe(res3=>{
        this.profileImagePath = res3[0].payload.doc.data()['fbs_download_url'];
        this.editProfileForm.patchValue({ 
          first_name : `${firstName}`,
          last_name : `${lastName}`,
          mobile_phone : res[0].payload.doc.data()['mobile_phone'],
          file : [null, [Validators.required]]
        })
      },err=>{
        console.error(err,'error while getting profile detail');
      })

    },err=>{
      console.error(err,'error while getting profile detail');
    })
  }

  showPreview(event) {
    this.selectedFile = event.target.files[0];
    this.editProfileForm.get('file').updateValueAndValidity()

    // File Preview
    const reader = new FileReader();
    reader.onload = () => {
      this.imageURL = reader.result as string;
    }
    reader.readAsDataURL(event.target.files[0])
   
    
  }

// Submit Form
onFormSubmit() {
  this._common.showLoader(true);
  if(this.selectedFile){
    const uid = localStorage.getItem('uid');  
    const randomId = Math.random().toString(36).substring(2);
    this.ref = this.afStorage.ref(`profile_photos/${this.contactId}/${randomId}-${this.selectedFile.name}`);
    const task = this.afStorage.upload(`profile_photos/${this.contactId}/${randomId}-${this.selectedFile.name}`,this.selectedFile);
    
    task.snapshotChanges().pipe(
      finalize(() => {
        this.downloadURL = this.ref.getDownloadURL();
        this.downloadURL.subscribe(url => {
          if (url) {
          

            let data ={
              first_name :this.editProfileForm.value.first_name,
              last_name :this.editProfileForm.value.last_name,
              mobile_phone : this.editProfileForm.value.mobile_phone ? this.editProfileForm.value.mobile_phone : ''
            }
            
            this._profile.updateProfile(this.contactId,data).then(res => {
              // Create/Update File documents
              let fileObj = {
                id : this.contactId,
                date_created : new Date().getTime(),
                is_profile_photo : 'Yes',
                contact_id : this.contactId,
                fbs_download_url : url,
                fbs_path : `profile_photos/${this.contactId}/${randomId}-${this.selectedFile.name}`
              }
              this._profile.createFileDocument(fileObj).then(resp=>{
                this._admin.getUserDetailByUID(this.userId).subscribe(result=>{
                  const obj = {
                    firstName : result[0].payload.doc.data().first_name,
                    lastName : result[0].payload.doc.data().last_name,
                    profileImagePath : url
                  }
                  this._profile.updateProfileStatus(obj);
  
                  localStorage.setItem('firstName',result[0].payload.doc.data().first_name);
                  localStorage.setItem('lastName',result[0].payload.doc.data().last_name);
                  localStorage.setItem('profileImagePath', url);
                  this._common.showLoader(false);
                  this.successMsg = "Profile updated successfully!"
    
                },err=>{
                  this.errMsg = "Something went wrong";
                })
              }).catch(err=>{
                this._common.showLoader(false);
                this.errMsg = "Something went wrong";
              })

            },err=>{
              this._common.showLoader(false);
              this.errMsg = "Something went wrong";
  
            })   
          }
        });
      })
    ).subscribe(url => {})
  }else {
    let data ={
      first_name :this.editProfileForm.value.first_name,
      last_name :this.editProfileForm.value.last_name,
      mobile_phone : this.editProfileForm.value.mobile_phone ? this.editProfileForm.value.mobile_phone : ''
    }
    this._profile.updateProfile(this.contactId,data).then(res => {
      this._common.showLoader(false);
      this.successMsg = "Profile updated successfully!"
    },err=>{
      this._common.showLoader(false);
      this.errMsg = "Something went wrong";

    })   
  }
  
}

ngOnDestroy (){
  this.detroyed$.next();
  this.detroyed$.complete();
  if(this.subscription){
    this.subscription.unsubscribe();
  }
}



}
